import { AuthPage } from './AuthPage';

export const SignUp = () => <AuthPage mode="signup" />;
